class CustomSelect {
  constructor() {
    this.init();
  }

  init() {
    const customSelects = document.getElementsByClassName("custom-select");
    
    for (let i = 0; i < customSelects.length; i++) {
      const select = customSelects[i].getElementsByTagName("select")[0];
      this.createCustomSelect(customSelects[i], select);
    }

    document.addEventListener("click", this.closeAllSelect);
  }


  createCustomSelect(wrapper, select) {
    const selectedDiv = document.createElement("DIV");
    selectedDiv.setAttribute("class", "select-selected");
    selectedDiv.innerHTML = select.options[select.selectedIndex].innerHTML;
    wrapper.appendChild(selectedDiv);

    const optionsDiv = document.createElement("DIV");
    optionsDiv.setAttribute("class", "select-items select-hide");

    for (let j = 1; j < select.length; j++) {
      const optionDiv = document.createElement("DIV");
      optionDiv.innerHTML = select.options[j].innerHTML;
      
      optionDiv.addEventListener("click", (e) => {
        this.updateSelection(e.target, select);
      });
      
      optionsDiv.appendChild(optionDiv);
    }

    wrapper.appendChild(optionsDiv);
    
    selectedDiv.addEventListener("click", (e) => {
      e.stopPropagation();
      this.closeAllSelect(e.target);
      e.target.nextSibling.classList.toggle("select-hide");
      e.target.classList.toggle("select-arrow-active");
    });
  }

  updateSelection(clickedOption, select) {
    const parent = clickedOption.parentNode;
    const header = parent.previousSibling;

    for (let i = 0; i < select.length; i++) {
      if (select.options[i].innerHTML === clickedOption.innerHTML) {
        select.selectedIndex = i;
        header.innerHTML = clickedOption.innerHTML;
        
        const sameAsSelected = parent.getElementsByClassName("same-as-selected");
        for (let k = 0; k < sameAsSelected.length; k++) {
          sameAsSelected[k].removeAttribute("class");
        }
        
        clickedOption.setAttribute("class", "same-as-selected");
        break;
      }
    }

    header.click();
    const event = new Event('change', { bubbles: true });
    select.dispatchEvent(event);
  }

  closeAllSelect(elmnt) {
    const selectItems = document.getElementsByClassName("select-items");
    const selectedItems = document.getElementsByClassName("select-selected");
    const arrNo = [];

    for (let i = 0; i < selectedItems.length; i++) {
      if (elmnt === selectedItems[i]) {
        arrNo.push(i);
      } else {
        selectedItems[i].classList.remove("select-arrow-active");
      }
    }

    for (let i = 0; i < selectItems.length; i++) {
      if (arrNo.indexOf(i)) {
        selectItems[i].classList.add("select-hide");
      }
    }
  }
}

// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  new CustomSelect();
});
